var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{class:{'title h4': _vm.title},attrs:{"to":{name: 'user.view', params: {username: _vm.user.username}}}},[(_vm.user.challenge_winner)?_c('i',{staticClass:"fas fa-award text-primary me-1"}):_vm._e(),_vm._v("\n        "+_vm._s(_vm.user.username)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }